import { Checkbox, FormControlLabel, Stack, Typography, styled, type SxProps, type Theme } from "~/common/mui";
import { ControlInfo } from "./ControlInfo";
import type { CheckboxControlViewModel } from "./controlViewModel";

export interface CheckboxControlProps extends Omit<CheckboxControlViewModel, "type" | "controlIndex"> {
  onChange: (value: string) => void;
  appearance?: "default" | "carouselDetail";
  className?: string;
  sx?: SxProps<Theme>;
}

const Root = styled(Stack, {
  shouldForwardProp: (prop) => prop !== "appearance",
})<{ appearance: "default" | "carouselDetail" }>({});

export const CheckboxControl = ({
  label,
  hideLabel,
  info,
  helperText,
  error,
  errorText,
  disabled = false,
  value,
  checkedValue,
  uncheckedValue,
  onChange,
  appearance = "default",
  className,
  sx,
}: CheckboxControlProps) => (
  <Root appearance={appearance} className={className} sx={sx} gap={0.5} alignItems="flex-start">
    <FormControlLabel
      disabled={disabled}
      control={
        <Checkbox
          checked={value === checkedValue}
          inputProps={{ "aria-invalid": Boolean(error), "aria-label": label }}
          sx={error ? { color: "error.main", "&.Mui-checked": { color: "error.main" } } : undefined}
          onChange={() => onChange(value === checkedValue ? uncheckedValue : checkedValue)}
        />
      }
      label={
        hideLabel ? null : (
          <Stack direction="row" gap={1} alignItems="center">
            <Typography variant="bodyLarge" color={error ? "error" : "textPrimary"}>
              {label}
            </Typography>
            {info ? <ControlInfo {...info} /> : null}
          </Stack>
        )
      }
    />
    {errorText ?? helperText ? (
      <Typography variant="bodySmall" color={error ? "error" : "textSecondary"}>
        {errorText ?? helperText}
      </Typography>
    ) : null}
  </Root>
);
